import { render, staticRenderFns } from "./PhysicalFranchiseList.vue?vue&type=template&id=9e7117ae&scoped=true"
import script from "./PhysicalFranchiseList.vue?vue&type=script&lang=js"
export * from "./PhysicalFranchiseList.vue?vue&type=script&lang=js"
import style0 from "./PhysicalFranchiseList.vue?vue&type=style&index=0&id=9e7117ae&prod&lang=scss&scoped=true"
import style1 from "./PhysicalFranchiseList.vue?vue&type=style&index=1&id=9e7117ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7117ae",
  null
  
)

export default component.exports